/* eslint-disable import/no-cycle */
/* eslint-disable import/no-cycle */
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { ActionIcon, Tooltip } from '@mantine/core';
import { Link as LinkIcon, Share } from 'tabler-icons-react';
import AppFlexbox from '../../../../common/AppFlexbox';
import AppText from '../../../../common/AppText';
import AppMenu from '../../../../common/AppMenu';
import * as classes from '../../../../../styles/nestedStyles.module.css';
import { triggerNotification } from '../../../../../helpers/notification';
import { Context as HelperContext } from '../../../../../providers/HelperContextProvider';
import {
  SOCIAL_SHARING_LIST,
  STORE_HOSTING_URL
} from '../../../../../config/constants';

const WsShareButtonsDisplay = ({
  themeConfig,
  colorScheme,
  menuColorScheme,
  baseStoreUrl,
  showTooltips,
  shareImageUrl,
  showIcons,
  maxIconsShown,
  iconSize,
  buttonFlow,
  isHeader,
  isResourceShare
}) => {
  const { toggleWebstoreSocialSharingModel } = useContext(HelperContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const shareUrl = `${STORE_HOSTING_URL}${baseStoreUrl}`;
  const socials = SOCIAL_SHARING_LIST.filter(
    (f) => themeConfig[f.webstoreConfigValue] === 'true'
  );
  const isMoreOptionsVisible = !showIcons || maxIconsShown < socials.length;
  const iconDisplaySize = iconSize || 26;

  return (
    <AppFlexbox style={{ gap: 8, flexWrap: 'wrap', maxWidth: '100%' }}>
      {showIcons &&
        socials
          .slice(0, maxIconsShown)
          .map(({ value, Icon, ShareComponent }) => (
            <ShareComponent key={value} media={shareImageUrl} url={shareUrl}>
              <AppFlexbox>
                <Icon
                  style={{
                    borderRadius: 100,
                    width: iconDisplaySize,
                    height: iconDisplaySize
                  }}
                />
              </AppFlexbox>
            </ShareComponent>
          ))}

      {buttonFlow === 'model' ? (
        <Tooltip
          disabled={!showTooltips}
          label="Share"
          position="bottom"
          styles={{
            tooltip: {
              backgroundColor: menuColorScheme.backgroundColor,
              color: menuColorScheme.textColor
            }
          }}
          withArrow
        >
          {isHeader ? (
            <ActionIcon
              color="dark"
              onClick={() =>
                toggleWebstoreSocialSharingModel({
                  isOpen: true,
                  shareUrl,
                  isResourceUrl: isResourceShare
                })
              }
              radius="lg"
              size="lg"
              variant="subtle"
            >
              <Share color={colorScheme.textColor} />
            </ActionIcon>
          ) : (
            <ActionIcon
              color="dark"
              onClick={() =>
                toggleWebstoreSocialSharingModel({
                  isOpen: true,
                  shareUrl,
                  isResourceUrl: isResourceShare
                })
              }
              radius={100}
              size={iconDisplaySize}
              variant="subtle"
            >
              <Share
                color={colorScheme.textColor}
                style={{
                  width: '85%',
                  height: '85%'
                }}
              />
            </ActionIcon>
          )}
        </Tooltip>
      ) : (
        <AppMenu
          control={
            <Tooltip
              disabled={!showTooltips}
              label="Share"
              position="bottom"
              styles={{
                tooltip: {
                  backgroundColor: menuColorScheme.backgroundColor,
                  color: menuColorScheme.textColor
                }
              }}
              withArrow
            >
              {isHeader ? (
                <ActionIcon color="dark" radius="lg" size="lg" variant="subtle">
                  <Share color={colorScheme.textColor} />
                </ActionIcon>
              ) : (
                <ActionIcon
                  color="dark"
                  radius={100}
                  size={iconDisplaySize}
                  variant="subtle"
                >
                  <Share
                    color={colorScheme.textColor}
                    style={{
                      width: '85%',
                      height: '85%'
                    }}
                  />
                </ActionIcon>
              )}
            </Tooltip>
          }
          onChange={setIsMenuOpen}
          opened={isMenuOpen}
          width={200}
        >
          {socials
            .slice(showIcons ? maxIconsShown : 0, socials.length)
            .map(({ value, name, Icon, ShareComponent }) => (
              <AppFlexbox
                key={value}
                className={classes['hover-action-card']}
                onClick={() => setIsMenuOpen(false)}
                style={{ padding: '5px 10px', borderRadius: 4 }}
              >
                <ShareComponent media={shareImageUrl} url={shareUrl}>
                  <AppFlexbox
                    style={{
                      flex: 1,
                      gap: 10,
                      alignItems: 'center'
                    }}
                  >
                    <Icon
                      style={{
                        borderRadius: 100,
                        width: 32,
                        height: 32
                      }}
                    />
                    <AppText style={{ fontSize: 14 }}>Share to {name}</AppText>
                  </AppFlexbox>
                </ShareComponent>
              </AppFlexbox>
            ))}

          <AppFlexbox
            className={classes['hover-action-card']}
            onClick={() => {
              navigator.clipboard.writeText(shareUrl);
              triggerNotification('Link copied to clipboard', 'success');
              setIsMenuOpen(false);
            }}
            style={{ padding: '5px 10px', borderRadius: 4 }}
          >
            <AppFlexbox
              style={{
                flex: 1,
                gap: 10,
                alignItems: 'center'
              }}
            >
              <LinkIcon
                style={{
                  borderRadius: 100,
                  width: 32,
                  height: 32
                }}
              />
              <AppText style={{ fontSize: 14 }}>Copy link</AppText>
            </AppFlexbox>
          </AppFlexbox>
        </AppMenu>
      )}
    </AppFlexbox>
  );
};

WsShareButtonsDisplay.propTypes = {
  baseStoreUrl: PropTypes.string,
  buttonFlow: PropTypes.string,
  colorScheme: PropTypes.object,
  iconSize: PropTypes.number,
  isHeader: PropTypes.bool,
  isResourceShare: PropTypes.bool,
  maxIconsShown: PropTypes.number,
  menuColorScheme: PropTypes.object,
  shareImageUrl: PropTypes.string,
  showIcons: PropTypes.bool,
  showTooltips: PropTypes.bool,
  themeConfig: PropTypes.object
};

export default WsShareButtonsDisplay;
